
const routes = [
	{
		path:      '/auth/sign-out',
		name:      'auth.signOut',
		component: () => import(/* webpackChunkName: "auth.signOut" */ '../views/auth/signOut.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       false,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/auth/sign-in',
		name:      'auth.signIn',
		component: () => import(/* webpackChunkName: "auth.signIn" */ '../views/auth/signIn.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       false,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/auth/silent-sign-in',
		name:      'auth.silentSignIn',
		component: () => import(/* webpackChunkName: "auth.signIn" */ '../views/auth/silentSignIn.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       false,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/auth/error',
		name:      'auth.error',
		component: () => import(/* webpackChunkName: "auth.error" */ '../views/auth/error.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       false,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/',
		name:      'root',
		component: () => import(/* webpackChunkName: "root" */ '../views/Home.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       true,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/sign/:documentId',
		name:      'sign',
		component: () => import(/* webpackChunkName: "sign" */ '../views/sign/sign.vue'),
		props:     route => ({ documentId:route.params.documentId, token: route.query.token }),
		meta:      {
			auth: {
				required:       false
			}
		}
	},
	{
		path:      '/terminal/:documentId',
		name:      'terminal',
		component: () => import(/* webpackChunkName: "sign" */ '../views/sign/terminal.vue'),
		props:     route => ({ documentId:route.params.documentId, token: route.query.token }),
		meta:      {
			auth: {
				required:       false
			}
		}
	},
	{
		path:      '/document/:documentId',
		name:      'document',
		component: () => import(/* webpackChunkName: "document" */ '../views/document/document.vue'),
		props:     route => ({ documentId:route.params.documentId }),
		meta:      {
			auth: {
				required:       true,
				readRoles:  [],
				writeRoles: []
			}
		}
	},
	{
		path:      '/user',
		name:      'user.list',
		component: () => import(/* webpackChunkName: "user" */ '../views/user/user.list.vue'),
		props:     true,
		meta:      {
			auth: {
				required:       true,
				readRoles:  [ 'User.Read' ],
				writeRoles: [ 'User.Read', 'User.Write' ]
			}
		}
	},
	{
		path:      '/user/:userId',
		name:      'user',
		component: () => import(/* webpackChunkName: "user" */ '../views/user/user.vue'),
		props:     route => ({ userId:route.params.userId }),
		meta:      {
			auth: {
				required:       true,
				readRoles:  [ 'User.Read' ],
				writeRoles: [ 'User.Read', 'User.Write' ]
			}
		}
	},
	{
		path:      '*',
		name:      'error',
		component: () => import(/* webpackChunkName: "error" */ '../views/error/errorPage.vue'),
		meta:      {
			auth: {
				required:       true,
				readRoles:  [],
				writeRoles: []
			}
		}
	}
]
export default routes;
